import {ExternalLinkIcon, StatusOnlineIcon} from '@heroicons/react/outline';
import type {JSX} from 'react';

import {SYSTEM_HEALTH_DASHBOARD_URL} from '@/config/endpoints';

/**
 * The sidebar entry for the system health dashboard.
 *
 * Lives in the pinned sidebar footer rather than in the menu: the menu scrolls
 * and its items are Admin routes filtered by role, while this is an external
 * link everyone should be able to find from any page.
 */
export default function SystemHealthLink(): JSX.Element {
  return (
    <a
      href={SYSTEM_HEALTH_DASHBOARD_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-cy="admin-system-health-link"
      className="flex items-center gap-2 text-gray-700 hover:text-cyan-700 dark:text-gray-100 dark:hover:text-[#0075FF]"
    >
      <StatusOnlineIcon className="w-5 h-5 shrink-0" aria-hidden="true" />
      <span className="flex flex-col">
        <span className="text-sm font-medium flex items-center gap-1">
          System health
          <ExternalLinkIcon className="w-3.5 h-3.5" aria-hidden="true" />
        </span>
        <span className="text-xs text-gray-500 dark:text-gray-400">
          Opens Datadog
        </span>
      </span>
      <span className="sr-only">(opens in a new tab)</span>
    </a>
  );
}
